import RegularGameIcon from "../assets/icons/regular-game-icon.svg";
import StandardGameIcon from "../assets/icons/standard-game-icon.svg";
import PremiumGameIcon from "../assets/icons/premium-game-icon.svg";
import GameIcon from "../assets/icons/game-icon.svg";
import FriendsIcon from "../assets/icons/friends-icon.svg";
import RulesIcon from "../assets/icons/rules-icon.svg";
import QuestIcon from "../assets/icons/quest-icon.svg";
import ProfileIcon from "../assets/icons/profile-icon.svg";
import FriendsGroupIcon from "../assets/icons/friends-group-icon.svg";
import InviteIcon from "../assets/icons/invite-icon.svg";
import EarningsIcon from "../assets/icons/earnings-icon.svg";
import Img_1 from "../assets/images/rules/img_1.svg";
import Img_2 from "../assets/images/rules/img_5.svg";
import Img_3 from "../assets/images/rules/img_8.svg";
import Img_4 from "../assets/images/rules/img_4.svg";
import Img_5 from "../assets/images/rules/img_9.svg";
import Img_6 from "../assets/images/rules/img_10.svg";
import Img_7 from "../assets/images/rules/img_11.svg";
import Img_8 from "../assets/images/rules/img_2.svg";
import Img_9 from "../assets/images/rules/img_7.svg";

import {
    BUY_GAS_RESERVE_NANO,
    CYCLE_TICKETS,
    MEGA_FUND_PERCENT,
    MEGA_PRIZE_PERCENT,
    PRIZE_TIERS,
    REFERRAL_MILESTONE_FRIENDS,
    REFERRAL_WIN_PERCENTS,
    WIN_STREAK_BONUS_TICKETS,
    WIN_STREAK_LENGTH,
} from "./lotteryRules";
import { formatGram } from "../utils/gram";

const PRIZE_COUNT = PRIZE_TIERS.reduce((total, tier) => total + tier.count, 0);
const PRIZE_TIERS_TEXT = PRIZE_TIERS
    .map((tier) => `${tier.count} × ${tier.multiplier}X`)
    .join(", ");

export const gameCategoryCards = [
    {
        name: "Регулярная игра",
        subTitle: "Стоимость билета",
        icon: RegularGameIcon,
        level: 0,
        route: "regular-game"
    },
    {
        name: "Стандартная игра",
        subTitle: "Стоимость билета",
        icon: StandardGameIcon,
        level: 1,
        route: "standard-game"
    },
    {
        name: "Премиум игра",
        subTitle: "Стоимость билета",
        icon: PremiumGameIcon,
        level: 2,
        route: "premium-game"
    },
];



export const footerItems = [
    {
        name: "Игры",
        icon: GameIcon
    },
    {
        name: "Друзья",
        icon: FriendsIcon
    },
    {
        name: "Задания",
        icon: QuestIcon
    },
    {
        name: "Правила",
        icon: RulesIcon
    },

    {
        name: "Профиль",
        icon: ProfileIcon,
    },
]

export const AllTicketsCount = CYCLE_TICKETS;

export const referralProgramInfo = [
    {
        icon: FriendsGroupIcon,
        name: "Мои друзья"
    },
    {
        icon: InviteIcon,
        name: "Приглашенных друзей"
    },
    {
        icon: EarningsIcon,
        name: "Заработок от друзей"
    },
]

export const rulesInfo = [
    {
        icon: Img_1,
        title: "Участие в лотерее",
        content_1: "Для участия достаточно подключить TON-кошелёк. Отдельная регистрация не нужна: смарт-контракт создаёт игрока при первой покупке билета.",
        content_2: "Покупка билета — это перевод его стоимости в GRAM на адрес смарт-контракта лотереи.",
        content_3: `Каждому билету присваивается номер от 1 до ${CYCLE_TICKETS}, который записывается в блокчейн.`,
    },
    {
        icon: Img_2,
        title: "Стоимость билета",
        content_1: "Цена билета задаётся смарт-контрактом и указана на странице каждой игры.",
        content_2: "Оплата принимается только в GRAM — нативной монете сети TON.",
        content_3: `К каждой покупке добавляется ${formatGram(BUY_GAS_RESERVE_NANO)} GRAM сетевого резерва. Он остаётся на контракте и не возвращается.`,
    },
    {
        icon: Img_3,
        title: "Период проведения",
        content_1: `В каждой игре идёт свой тираж на ${CYCLE_TICKETS} билетов.`,
        content_2: "Розыгрыш начинается автоматически, как только продан последний билет тиража.",
        content_3: "Пока идёт розыгрыш, покупка билетов в этой игре недоступна. После розыгрыша открывается новый тираж.",
    },
    {
        icon: Img_4,
        title: "Прозрачность и честность",
        content_1: "Смарт-контракт лотереи открыт и доступен для проверки в блокчейне TON.",
        content_2: "Победители определяются смарт-контрактом с помощью встроенного генератора случайных чисел.",
        content_3: "Все данные о билетах, участниках и результатах фиксируются в блокчейне и не подлежат изменению.",
    },
    {
        icon: Img_5,
        title: "Призовой фонд",
        content_1: "Призы выплачиваются с баланса смарт-контракта, который пополняется продажей билетов.",
        content_2: `В каждом тираже разыгрывается ${PRIZE_COUNT} приза: ${PRIZE_TIERS_TEXT} (X — цена билета).`,
        content_3: `${MEGA_FUND_PERCENT}% стоимости каждого билета отправляется в фонд Мега Джекпота.`,
    },
    {
        icon: Img_6,
        title: "Определение победителей",
        content_1: `Выигрышные номера выбираются случайно среди ${CYCLE_TICKETS} билетов тиража. Один билет может выиграть несколько раз.`,
        content_2: "Результаты розыгрыша фиксируются в блокчейне и доступны для проверки.",
    },
    {
        icon: Img_7,
        title: "Выплата выигрышей",
        content_1: "Выигрыши автоматически отправляются на кошельки, с которых были куплены билеты, если на балансе смарт-контракта достаточно средств.",
        content_2: "Участники несут ответственность за доступ к своему кошельку. В случае утери доступа организаторы не несут ответственности за невыданный выигрыш.",
    },
    {
        icon: Img_8,
        title: "Ограничения и ответственность",
        content_1: "Участие запрещено лицам, проживающим в юрисдикциях, где участие в лотереях запрещено законом.",
        content_2: "Организаторы не несут ответственности за технические сбои в сети блокчейна, влияющие на процесс лотереи.",
        content_3: "Участие в лотерее подразумевает согласие с указанными правилами.",
    },
    {
        icon: Img_9,
        title: "Прочие условия",
        content_1: "Владелец смарт-контракта может изменять цены билетов и параметры Мега Джекпота. Призы тиража рассчитываются от цены билета на момент его завершения.",
        content_2: "Все изменения выполняются транзакциями в блокчейне и доступны для проверки.",
    },
];

export const FaqItems = [
    {
        title: "Как приобрести билет?",
        content: "Нажмите «Подключить кошелёк» и подключите TON-кошелёк через TON Connect, например Tonkeeper или кошелёк в Telegram. Выберите игру, количество билетов или конкретный номер и подтвердите транзакцию в кошельке. Оплата в GRAM уходит напрямую на смарт-контракт, номера билетов записываются в блокчейн и появляются в разделе «Профиль».",
    },
    {
        title: "Какая стоимость билета?",
        content: `Цена билета задаётся смарт-контрактом и показана на странице каждой игры. К оплате добавляется ${formatGram(BUY_GAS_RESERVE_NANO)} GRAM сетевого резерва, он остаётся на контракте. Убедитесь, что на кошельке хватает средств на билеты, резерв и комиссию сети.`,
    },
    {
        title: "Сколько я могу приобрести билетов?",
        content: `В каждом тираже ${CYCLE_TICKETS} билетов. Купить можно любое количество в пределах оставшихся билетов тиража. Когда тираж заполнен, покупка в этой игре недоступна до завершения розыгрыша.`,
    },
    {
        title: "Как часто происходит розыгрыш?",
        content: `Розыгрыш начинается, как только продан ${CYCLE_TICKETS}-й билет тиража. Смарт-контракт определяет победителей и отправляет выигрыши на их кошельки, после чего открывается новый тираж.`,
    },
    {
        title: "Как распределяется выигрыш?",
        content: `В каждом тираже разыгрывается ${PRIZE_COUNT} приза (X — цена билета): ${PRIZE_TIERS_TEXT}. Один билет может выиграть несколько раз.`,
    },
    {
        title: "Как выиграть Джекпот?",
        content: `Главный приз тиража — ${PRIZE_TIERS[0].multiplier}X — получает номер, выбранный первым при розыгрыше. Номера выбираются случайно, поэтому чем больше у вас билетов в тираже, тем выше шанс.`,
    },
    {
        title: "Как выиграть Мегаджекпот?",
        content: `С каждого купленного билета ${MEGA_FUND_PERCENT}% отправляется в фонд Мега Джекпота. Когда фонд достигает порога (прогресс показан на странице Мега Джекпота), розыгрыш запускается автоматически и в продажу выходят мега-билеты. Приз — ${MEGA_PRIZE_PERCENT}% от суммы фонда и продаж мега-билетов. Как только проданы все мега-билеты, смарт-контракт сразу выбирает одного победителя.`,
    },
    {
        title: "Какое реферальное вознаграждение?",
        content: `С каждой покупки приглашённых друзей вы получаете 3%, после 10 купленных ими билетов — 5%, после 25 — 10%. Также вы получаете ${REFERRAL_WIN_PERCENTS[0]}% от выигрыша друга, ${REFERRAL_WIN_PERCENTS[1]}% — от выигрыша друга вашего друга и ${REFERRAL_WIN_PERCENTS[2]}% — на третьем уровне. За каждые ${REFERRAL_MILESTONE_FRIENDS} приглашённых друзей начисляется бонус — 1/5 базовой цены билета, для игроков 2-го и 3-го уровня — в 2 и 4 раза больше.`,
    },
    {
        title: "Какие бонусы можно получить?",
        content: `За покупки: за 10 купленных билетов — бонус 1/5 цены билета и 2-й уровень игрока, за 60 билетов — бонус в 2 цены билета и 3-й уровень, затем за каждые 100 билетов сверх 60 — по 6 цен билета. За победы: выиграйте в ${WIN_STREAK_LENGTH} тиражах подряд в одной игре — бонус ${WIN_STREAK_BONUS_TICKETS} цены билета. Бонусы выплачиваются смарт-контрактом сразу, если на его балансе достаточно средств.`,
    },
];

export const touchItems = [
    {
        title: "Регулярная игра",
        subtitle: "билетов",
        icon: RegularGameIcon,
    },
    {
        title: "Стандартная игра",
        subtitle: "билетов",
        icon: StandardGameIcon,
    },
    {
        title: "Премиум игра",
        subtitle: "билетов",
        icon: PremiumGameIcon,
    },
];

export const generateArray = () => {
    let arr: any = []
    for (let i = 1; i < 778; i++) {
        let item = {
            ticket_number: i.toString(),
            is_active: Math.random() < 0.7
        }
        arr.push(item)
    }
    return arr
}